module.exports = __webpack_public_path__ + "static/osmond-c7f0d87963b623cb90d22e514cbd4bb3.png";